module.exports = __webpack_public_path__ + "img/Marquee.09be45ef.jpg";